/* eslint-disable */
import { useParams, useNavigate } from "react-router-dom";

function withParams(Component) {
  return (props) => <Component {...props} navigate={useNavigate()} params={useParams()} />;
}

export default withParams;
